import { db } from './firebase.js';
import { addDoc, collection, query, and, or, updateDoc, getDocs, where, orderBy, doc } from 'firebase/firestore';
let seedrandom = require('seedrandom');

//  all of the collections in the database

// ORIGINAL EXP 1 (CHI PAPER)
const workersRef = collection(db, 'workers'); // participant info
const demographicsRef = collection(db, 'demographics'); // demographics
const highlightsRef = collection(db, 'highlights'); // highlight events
const highlightedPassagesRef = collection(db, 'highlightedPassages'); // final highlighted passages
const postHighlightRef = collection(db, 'postHighlight'); // post-highlight questions
const passagesRef = collection(db, 'passages'); // passage info
const readingComprehensionSelectionRef = collection(db, 'readingComprehensionSelection'); // reading comprehension selections
const readingComprehensionRef = collection(db, 'readingComprehension'); // reading comprehension results
const postTestRef = collection(db, 'postTest'); // post-test questions

// NEW EXP 2 (TECHNIQUES) - exp1-tweaking
const workersTweakingRef = collection(db, 'workersTweaking'); // participant info
const demographicsTweakingRef = collection(db, 'demographicsTweaking'); // demographics
const settingsTweakingRef = collection(db, 'settingsTweaking'); // settings the participant manipulates in pass 1
const finalSettingsTweakingRef = collection(db, 'finalSettingsTweaking'); // settings the participant manipulates in pass 2
const allSettingsTweakingRef = collection(db, 'allSettingsTweaking'); // all settings the participant manipulates
const highlightsTweakingRef = collection(db, 'highlightsTweaking'); // highlight events
const postTweakingFeedbackRef = collection(db, 'postTweakingFeedback'); // post-tweaking feedback

// NEW EXP 3 (HIGHLIGHTS) - exp2-highlights
const workersHighlightsRef = collection(db, 'workersHighlights'); // participant info
const demographicsHighlightsRef = collection(db, 'demographicsHighlights'); // demographics
const highlightsHighlightsRef = collection(db, 'highlightsHighlights'); // highlight events
const highlightedPassagesHighlightsRef = collection(db, 'highlightedPassagesHighlights'); // final highlighted passages
const postHighlightHighlightsRef = collection(db, 'postHighlightHighlights'); // post-highlight questions
const readingComprehensionSelectionHighlightsRef = collection(db, 'readingComprehensionSelectionHighlights'); // reading comprehension selections
const readingComprehensionHighlightsRef = collection(db, 'readingComprehensionHighlights'); // reading comprehension results
const postTestHighlightsRef = collection(db, 'postTestHighlights'); // post-test questions
const passagesHighlightsRef = collection(db, 'passagesHighlights'); // passage info


// NEW EXP 3 (WITHIN-SUBJECTS HIGHLIGHTS) - exp3-withinHighlights
const workersWithinHighlightsRef = collection(db, 'workersWithinHighlights'); // participant info
const demographicsWithinHighlightsRef = collection(db, 'demographicsWithinHighlights'); // demographics
const highlightsWithinHighlightsRef = collection(db, 'highlightsWithinHighlights'); // highlight events
const highlightedPassagesWithinHighlightsRef = collection(db, 'highlightedPassagesWithinHighlights'); // final highlighted passages
const postHighlightWithinHighlightsRef = collection(db, 'postHighlightWithinHighlights'); // post-highlight questions
const postHighlightAdjustWithinHighlightRef = collection(db, 'postHighlightAdjustWithinHighlights'); // post-highlight questions for the adjustment phase
const readingComprehensionSelectionWithinHighlightsRef = collection(db, 'readingComprehensionSelectionWithinHighlights'); // reading comprehension selections
const readingComprehensionWithinHighlightsRef = collection(db, 'readingComprehensionWithinHighlights'); // reading comprehension results
const postTestWithinHighlightsRef = collection(db, 'postTestWithinHighlights'); // post-test questions

// CHANGE ME: Set the experiment name
const experiment = "exp3-withinHighlights";


function createCompletionCode(type) {
    // let code = "";
    // const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    // for (let i = 0; i < 5; i++) {
    //     code += characters.charAt(Math.floor(Math.random() * characters.length));
    // }
    // code += "-" + type + "-";
    // for (let i = 0; i < 5; i++) {
    //     code += characters.charAt(Math.floor(Math.random() * characters.length));
    // }
    // return code;

    if (type === "highlight") {
        return "C1LLR06M";
    }
    else {
        return "C1BJPP38";
    }
}

export function prepareForUpcomingTest(participantId, callbacks) {
    if (experiment === "exp3-withinHighlights") {
        const q = query(workersWithinHighlightsRef, where("participantId", "==", participantId));
        getDocs(q).then((querySnapshot) => {
            let latestDoc = querySnapshot.docs[querySnapshot.size - 1].data();
            let testConditions = latestDoc.testConditions;
            let currentIndex = 0;

            if (!testConditions) {
                let conditions = []
                if (latestDoc.expCondition === "time") {
                    conditions = ["tooltip", "time"];
                }
                else if (latestDoc.expCondition === "trailing") {
                    conditions = ["tooltip", "trailing"];
                }
                else if (latestDoc.expCondition === "redact") {
                    conditions = ["tooltip", "redact"];
                }

                // coin toss to randomize the order of conditions
                let rng = seedrandom();
                let coinToss = rng() < 0.5; // 50% chance for each order
                if (coinToss) {
                    testConditions = [conditions[0], conditions[1]];
                }
                else {
                    testConditions = [conditions[1], conditions[0]];
                }

                currentIndex = 0;
                callbacks.setCurrentIndex(0);

            }
            else {
                currentIndex = 1;
                callbacks.setCurrentIndex(1);
                updateDoc(querySnapshot.docs[querySnapshot.size - 1].ref, { currentIndex: 0 });
            }

            let currCondition = testConditions[currentIndex];
            callbacks.setCondition(currCondition);
            callbacks.setTestConditions(testConditions);
            callbacks.setPassage(latestDoc.passageTexts[currCondition].replaceAll("_", " \n"));
            callbacks.setTestQuestions(latestDoc.testQuestions[currCondition]);
            callbacks.setPage("nudging-test-instructions");

            updateDoc(querySnapshot.docs[querySnapshot.size - 1].ref, { testConditions: testConditions, currentIndex: currentIndex, currentStage: "nudging-test-instructions" });
        });
    }
}

// managing user accounts
export function getUserInfo(event, callbacks) {
    let q = null;

    // adjust the query based on the experiment
    if (experiment === "exp1-tweaking") {
        q = query(workersTweakingRef, where("workerId", "==", event.workerId));
    }
    else if (experiment === "exp2-highlights") {
        q = query(workersHighlightsRef, where("workerId", "==", event.workerId));
    }
    else if (experiment === "exp3-withinHighlights") {
        q = query(workersWithinHighlightsRef, where("workerId", "==", event.workerId));
    }
    else {
        q = query(workersRef, where("workerId", "==", event.workerId));
    }
    getDocs(q).then((querySnapshot) => {
        if (querySnapshot.size > 0) {
            // move the participant to the right stage if they already exist
            let latestDoc = querySnapshot.docs[querySnapshot.size - 1].data();
            callbacks.setWorkerId(latestDoc.workerId);
            callbacks.setParticipantId(latestDoc.participantId);

            if (experiment !== "exp3-withinHighlights") {
                callbacks.setPassage(latestDoc.passageText.replaceAll("_", " \n"));
                callbacks.setConstrainHighlights(latestDoc.constrainHighlights);
                callbacks.setMaxWordCount(latestDoc.maxWordCount);
            }

            if (experiment === "exp1-tweaking") {
                callbacks.setCondition(latestDoc.conditionOrder[latestDoc.conditionIndex])
                callbacks.setPass(latestDoc.pass);
                callbacks.setExperiment(latestDoc.experiment);
            }

            else if (experiment === "exp2-highlights") {
                callbacks.setCondition(latestDoc.condition);
                callbacks.setExperiment(latestDoc.experiment);

                if (latestDoc.currentStage === "nudging-test") {
                    callbacks.setTestStartTime(latestDoc.testStartTime);
                    callbacks.setTestQuestions(latestDoc.testQuestions);
                    // get the highlighted passage
                    const q3 = query(highlightedPassagesHighlightsRef, where("participantId", "==", latestDoc.participantId));
                    getDocs(q3).then((pQuerySnapshot) => {
                        let latestPDoc = pQuerySnapshot.docs[pQuerySnapshot.size - 1];
                        callbacks.setPreviousHighlights(latestPDoc.data().highlights);
                    });
                }

                else if (latestDoc.currentStage === "nudging-post-test-complete") {
                    callbacks.setTestCompletionCode(latestDoc.testCompletionCode);
                }
            }

            else if (experiment === "exp3-withinHighlights") {
                callbacks.setCurrentIndex(latestDoc.currentIndex);
                callbacks.setPassage(latestDoc.passageTexts[latestDoc.conditions[latestDoc.currentIndex]].replaceAll("_", " \n"));
                callbacks.setExperiment(latestDoc.experiment);
                callbacks.setCondition(latestDoc.conditions[latestDoc.currentIndex]);
                callbacks.setConditions(latestDoc.conditions);

                if (latestDoc.currentStage === "nudging-post-highlight-adjust") {
                    // get the previous responses for the adjustment phase
                    let prevResponsesQuery = query(postHighlightWithinHighlightsRef, where("participantId", "==", latestDoc.participantId));
                    getDocs(prevResponsesQuery).then((prevResponsesSnapshot) => {
                        prevResponsesSnapshot.docs.forEach((doc) => {
                            let data = doc.data();
                            if (data.mentalDemand !== undefined && data.physicalDemand !== undefined &&
                                data.temporalDemand !== undefined && data.performance !== undefined &&
                                data.effort !== undefined && data.frustration !== undefined &&
                                data.awareness !== undefined) {
                                callbacks.setPostHighlightResponses(prevResponses => {
                                    return { ...prevResponses, [data.condition]: data };
                                });
                            }
                        })
                    });
                }

                if (latestDoc.testConditions) {
                    callbacks.setTestConditions(latestDoc.testConditions);
                }
            }

            // participant has waited for long enough - move them to the test instructions page
            if (latestDoc.testUnlockTime && latestDoc.testUnlockTime < Date.now() && latestDoc.currentStage === "post-highlight-complete") {
                if (experiment === "exp3-withinHighlights") {
                    prepareForUpcomingTest(latestDoc.participantId, callbacks);
                }
                else {
                    updateDoc(querySnapshot.docs[querySnapshot.size - 1].ref, { currentStage: "test-instructions" });
                    callbacks.setPage("test-instructions");
                }
            }

            else if (latestDoc.currentStage === "nudging-test-instructions" && experiment === "exp3-withinHighlights") {
                let currCondition = latestDoc.testConditions[latestDoc.currentIndex];
                callbacks.setCurrentIndex(latestDoc.currentIndex);
                callbacks.setCondition(currCondition);
                callbacks.setTestConditions(latestDoc.testConditions);
                callbacks.setPassage(latestDoc.passageTexts[currCondition].replaceAll("_", " \n"));
                callbacks.setTestQuestions(latestDoc.testQuestions[currCondition]);
                callbacks.setPage("nudging-test-instructions");

                updateParticipantStage(latestDoc.participantId, "nudging-test-instructions", callbacks.setPage);
            }

            // participant is still waiting for time to pass - keep them on the waiting page
            else if (latestDoc.testUnlockTime && latestDoc.testUnlockTime >= Date.now() && latestDoc.currentStage === "post-highlight-complete") {
                callbacks.setHighlightCompletionCode(latestDoc.highlightCompletionCode);
                callbacks.setTestUnlockTime(latestDoc.testUnlockTime);
                callbacks.setPage(latestDoc.currentStage);
            }

            // participant was doing the test
            else if (latestDoc.currentStage === "test" && experiment === "exp3-withinHighlights") {
                let currCondition = latestDoc.testConditions[latestDoc.currentIndex];
                // get the highlighted passage
                const q2 = query(highlightedPassagesWithinHighlightsRef, where("participantId", "==", latestDoc.participantId), where("condition", "==", currCondition));
                getDocs(q2).then((pQuerySnapshot) => {
                    let latestHighlightDoc = pQuerySnapshot.docs[pQuerySnapshot.size - 1].data();
                    if (latestHighlightDoc.highlights) {
                        callbacks.setPreviousHighlights(latestHighlightDoc.highlights);
                    }
                    else {
                        callbacks.setPreviousHighlights([]);
                    }

                    // set the start time
                    const q3 = query(readingComprehensionWithinHighlightsRef, where("participantId", "==", latestDoc.participantId), where("condition", "==", currCondition));
                    getDocs(q3).then((rcQuerySnapshot) => {
                        let latestRC = rcQuerySnapshot.docs[rcQuerySnapshot.size - 1].data();
                        callbacks.setTestStartTime(latestRC.testStartTime);
                        callbacks.setCondition(currCondition);
                        callbacks.setTestConditions(latestDoc.testConditions);
                        callbacks.setPassage(latestDoc.passageTexts[currCondition].replaceAll("_", " \n"));
                        callbacks.setTestQuestions(latestDoc.testQuestions[currCondition]);


                        callbacks.setPage(latestDoc.currentStage);

                    });
                });
            }

            else if (latestDoc.currentStage === "test") {
                callbacks.setTestStartTime(latestDoc.testStartTime);

                // get the questions
                const q2 = query(passagesRef, where("passageId", "==", latestDoc.passageId));
                getDocs(q2).then((pQuerySnapshot) => {
                    let latestPDoc = pQuerySnapshot.docs[pQuerySnapshot.size - 1];
                    callbacks.setTestQuestions(latestPDoc.data().questions);
                });

                // get the highlighted passage
                const q3 = query(highlightedPassagesRef, where("participantId", "==", latestDoc.participantId));
                getDocs(q3).then((pQuerySnapshot) => {
                    let latestPDoc = pQuerySnapshot.docs[pQuerySnapshot.size - 1];
                    callbacks.setPreviousHighlights(latestPDoc.data().highlights);
                    callbacks.setPage(latestDoc.currentStage);
                });
            }

            else if (latestDoc.currentStage === "post-test-complete") {
                callbacks.setTestCompletionCode(latestDoc.testCompletionCode);
                callbacks.setPage(latestDoc.currentStage);
            }

            else {
                callbacks.setPage(latestDoc.currentStage);
            }
        }

        // the user does not exist - show the consent form
        else {
            callbacks.setWorkerId(event.workerId.toLowerCase());
            callbacks.setExperiment(experiment);
            callbacks.setPage("consent");
        }
    })
}

export function logNewUser(event, callbacks) {
    if (experiment === "exp1-tweaking") {
        // from https://www.lsac.org/lsat/taking-lsat/test-format/reading-comprehension/reading-comprehension-sample-questions (passage B)
        let passage = "Over the past two decades, an extreme view of global warming has developed. While it contains some facts, this view also contains exaggerations and misstatements, and has sometimes resulted in unreasonable environmental policies.\nAccording to this view, global warming will cause the polar ice to melt, raising global sea levels, flooding entire regions, destroying crops, and displacing millions of people. However, there is still a great deal of uncertainty regarding a potential rise in sea levels. Certainly, if the earth warms, sea levels will rise as the water heats up and expands. If the polar ice caps melt, more water will be added to the oceans, raising sea levels even further. There is some evidence that melting has occurred; however, there is also evidence that the Antarctic ice sheets are growing. In fact, it is possible that a warmer sea surface temperature will cause more water to evaporate, and when wind carries the moisture-laden air over the land, it will precipitate out as snow, causing the ice sheets to grow. Certainly, we need to have better knowledge about the hydrological cycle before predicting dire consequences as a result of recent increases in global temperatures.\nThis view also exaggerates the impact that human activity has on the planet. While human activity may be a factor in global warming, natural events appear to be far more important. The 1991 eruption of Mount Pinatubo in the Philippines, for example, caused a decrease in the average global temperature, while El Niño, a periodic perturbation in the ocean's temperature and circulation, causes extreme global climatic events, including droughts and major flooding. Of even greater importance to the earth's climate are letiations in the sun's radiation and in the earth's orbit. Climate letiability has always existed and will continue to do so, regardless of human intervention."

        // This experiment is simple enough, can counter-balance the conditions
        let conditionOrders = {
            1: ["time", "redact", "trailing"],
            2: ["time", "trailing", "redact"],
            3: ["trailing", "time", "redact"],
            4: ["trailing", "redact", "time"],
            5: ["redact", "trailing", "time"],
            0: ["redact", "time", "trailing"]
        };

        // assign experimental conditions
        getDocs(workersTweakingRef).then((querySnapshot) => {
            let numDocs = querySnapshot.size + 1;
            let conditionOrder = conditionOrders[numDocs % 6];
            let condition = conditionOrder[0];

            let participantInfo = {
                workerId: event.workerId,
                participantId: event.workerId + "-" + Date.now(),
                experiment: experiment,
                creationTime: Date.now(),
                firebaseUid: event.firebaseUid,
                consentGiven: true,
                currentStage: "demographics",
                passageText: passage,
                conditionIndex: 0,
                conditionOrder: conditionOrder,
                pass: 1,
            }

            addDoc(workersTweakingRef, participantInfo).then((docRef) => {
                callbacks.setCondition(condition);
                callbacks.setPass(1); // two pass approach to tweaking
                callbacks.setParticipantId(participantInfo.participantId);
                callbacks.setPassage(participantInfo.passageText.replaceAll("_", " \n"));
                callbacks.setPage(participantInfo.currentStage);
            })

        });

    }

    else if (experiment === "exp2-highlights") {

        getDocs(passagesHighlightsRef).then((querySnapshot) => {
            let rng = seedrandom();

            // Get a random passage
            let randomIndex = Math.floor(rng() * querySnapshot.size);
            let randomPassage = querySnapshot.docs[randomIndex].data();

            let conditions = [
                "tooltip",
                "redact",
                "time",
                "trailing",
            ];

            // assign a random condition
            let participantCondition = "";
            let cIndex = Math.floor(rng() * conditions.length);
            participantCondition = conditions[cIndex];

            let participantInfo = {
                workerId: event.workerId,
                participantId: event.workerId + "-" + Date.now(),
                experiment: experiment,
                creationTime: Date.now(),
                firebaseUid: event.firebaseUid,
                consentGiven: true,
                currentStage: "demographics",
                passageId: randomPassage.passageId,
                passageText: randomPassage.text,
                testQuestions: randomPassage.questions,
                condition: participantCondition,
            }

            addDoc(workersHighlightsRef, participantInfo).then((docRef) => {
                callbacks.setCondition(participantCondition);
                callbacks.setParticipantId(participantInfo.participantId);
                callbacks.setPassage(participantInfo.passageText.replaceAll("_", " \n"));
                callbacks.setPage(participantInfo.currentStage);
            });
        });
    }

    else if (experiment === "exp3-withinHighlights") {
        getDocs(passagesRef).then((querySnapshot) => {
            // Get 2 random passages that are not the same
            let rng = seedrandom();
            let randomIndex1 = Math.floor(rng() * querySnapshot.size);
            let randomIndex2 = Math.floor(rng() * querySnapshot.size);

            // Ensure the two passages are not the same
            while (randomIndex2 === randomIndex1) {
                randomIndex2 = Math.floor(rng() * querySnapshot.size);
            }

            let randomPassage1 = querySnapshot.docs[randomIndex1].data();
            let randomPassage2 = querySnapshot.docs[randomIndex2].data();

            // CHANGEME: Assign a random condition
            let conditions = [
                "redact",
                "tooltip"
            ];

            let participantInfo = {
                workerId: event.workerId,
                participantId: event.workerId + "-" + Date.now(),
                experiment: experiment,
                // expCondition: conditions[1], // the main exp condition (tooltip is baseline)
                expCondition: conditions[0], // the main exp condition (tooltip is baseline)
                creationTime: Date.now(),
                firebaseUid: event.firebaseUid,
                consentGiven: true,
                currentStage: "demographics",
                testTimeLimit: 5, // 5 minutes for the test

                passageIds: { [conditions[0]]: randomPassage1.passageId, [conditions[1]]: randomPassage2.passageId },
                passageTexts: { [conditions[0]]: randomPassage1.text, [conditions[1]]: randomPassage2.text },
                testQuestions: { [conditions[0]]: randomPassage1.questions, [conditions[1]]: randomPassage2.questions },
                conditions: conditions,
                currentIndex: 0, // start with the first condition
            }

            addDoc(workersWithinHighlightsRef, participantInfo).then((docRef) => {
                let currCondition = participantInfo.conditions[participantInfo.currentIndex];
                callbacks.setCondition(participantInfo.conditions[participantInfo.currentIndex]);
                callbacks.setConditions(participantInfo.conditions);
                callbacks.setExperiment(participantInfo.experiment);
                callbacks.setCurrentIndex(participantInfo.currentIndex);
                callbacks.setParticipantId(participantInfo.participantId);
                callbacks.setPassage(participantInfo.passageTexts[currCondition].replaceAll("_", " \n"));
                callbacks.setPage(participantInfo.currentStage);
                console.log(docRef.id);
            });

        });
    }

    // ORIGINAL CHI EXPERIMENT
    else {
        getDocs(passagesRef).then((querySnapshot) => {
            // Get a random passage
            let rng = seedrandom(event.firebaseUid, { entropy: true });
            let randomIndex = Math.floor(rng() * querySnapshot.size);
            let randomPassage = querySnapshot.docs[randomIndex];

            // CHANGEME: Assign a random condition
            // For Experiment 1 - Unconstrained
            // let condition = "unconstrained";
            // let maxWordCount = -1;

            // For Experiment 2 - Constrained + Unconstrained
            // let conditions = ["constrained-0", "constrained-50", "constrained-150", "constrained-250", "unconstrained"];
            let conditions = ["constrained-150", "unconstrained", "constrained-0"];
            // let conditions = ["constrained-0", "constrained-50", "constrained-150", "constrained-250"];
            // let conditions = ["unconstrained"];
            let condition = conditions[Math.floor(rng() * conditions.length)];

            let constrainHighlights = true;
            let maxWordCount = parseInt(condition.split("-")[1]);

            // if condition is unconstrained, set maxWordCount to -1
            if (condition === "unconstrained") {
                maxWordCount = -1;
                constrainHighlights = false;
            }



            // TODO: Open vs. Closed book test?

            // Create a new user account
            let participantInfo = {
                workerId: event.workerId,
                experiment: experiment,
                creationTime: Date.now(),
                firebaseUid: event.firebaseUid,
                consentGiven: true,
                currentStage: "demographics",
                participantId: event.workerId + "-" + Date.now(),
                passageId: randomPassage.data().passageId,
                passageText: randomPassage.data().text,
                condition: condition,
                maxWordCount: maxWordCount,
                constrainHighlights: constrainHighlights,
                testTimeLimit: 5, // 5 minutes
            };

            addDoc(workersRef, participantInfo).then((docRef) => {
                // Save the participant's info to the state
                callbacks.setParticipantId(participantInfo.participantId);
                callbacks.setPassage(participantInfo.passageText.replaceAll("_", " \n"));
                callbacks.setConstrainHighlights(participantInfo.constrainHighlights);
                callbacks.setMaxWordCount(participantInfo.maxWordCount);
                callbacks.setPage(participantInfo.currentStage);
            }).catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
            });
        });
    }
}

export function logDemographics(event, callbacks) {
    let newEvent = event;
    newEvent.timestamp = Date.now();

    if (experiment === "exp1-tweaking") {
        addDoc(demographicsTweakingRef, newEvent).then((docRef) => {
            updateParticipantStage(event.participantId, "tweaking", callbacks.setPage);
        }).catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
        });
    }

    else if (experiment === "exp2-highlights") {
        addDoc(demographicsHighlightsRef, newEvent).then((docRef) => {
            updateParticipantStage(event.participantId, "nudging-instructions", callbacks.setPage);
        }).catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
        });
    }

    else if (experiment === "exp3-withinHighlights") {
        addDoc(demographicsWithinHighlightsRef, newEvent).then((docRef) => {
            updateParticipantStage(event.participantId, "nudging-instructions", callbacks.setPage);
        }).catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
        });
    }

    else {

        addDoc(demographicsRef, newEvent).then((docRef) => {
            updateParticipantStage(event.participantId, "highlight-instructions", callbacks.setPage);

        }).catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
            // ...
        });
    }
}

export function logHighlightEvent(event) {

    if (experiment === "exp1-tweaking") {
        addDoc(highlightsTweakingRef, event).then((docRef) => { });
    }

    else if (experiment === "exp2-highlights") {
        addDoc(highlightsHighlightsRef, event).then((docRef) => { });
    }

    else if (experiment === "exp3-withinHighlights") {
        addDoc(highlightsWithinHighlightsRef, event).then((docRef) => { });
    }

    // Weird and inefficient but leaving as is for now
    else {
        let newEvent;
        if (event.type === "add") {
            newEvent = {
                unsnappedStart: event.unsnappedRange.start,
                unsnappedEnd: event.unsnappedRange.end,
                unsnappedText: event.unsnappedRange.text,
                snappedStart: event.snappedRange.start,
                snappedEnd: event.snappedRange.end,
                snappedText: event.snappedRange.text,
                participantId: event.participantId,
                validHighlight: event.validHighlight,
                newWordCount: event.newWordCount,
                tool: event.tool,
                type: event.type,
                timestamp: Date.now()
            };
        }

        else if (event.type === "delete") {
            newEvent = {
                snappedStart: event.snappedRange.start,
                snappedEnd: event.snappedRange.end,
                snappedText: event.snappedRange.text,
                participantId: event.participantId,
                type: event.type,
                timestamp: Date.now()
            };
        }

        addDoc(highlightsRef, newEvent).then((docRef) => {
        }).catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
            // ...
        });
    }


}

export function logStartHighlighting(event, callbacks) {
    if (experiment === "exp3-withinHighlights") {
        addDoc(highlightedPassagesWithinHighlightsRef, event).then((docRef) => {
            updateParticipantStage(event.participantId, "nudging", callbacks.setPage);
        });
    }
}

export function logHighlightedPassage(event, callbacks) {
    if (experiment === "exp2-highlights") {
        addDoc(highlightedPassagesHighlightsRef, event).then((docRef) => {
            updateParticipantData(event.participantId, { currentStage: "nudging-post-highlight", highlightEndTime: event.timestamp });
            callbacks.setPage("nudging-post-highlight");
        });
    }

    else if (experiment === "exp3-withinHighlights") {
        let q = query(highlightedPassagesWithinHighlightsRef, where("participantId", "==", event.participantId), where("condition", "==", event.condition));
        getDocs(q).then((querySnapshot) => {
            let latestDoc = querySnapshot.docs[querySnapshot.size - 1];
            updateDoc(latestDoc.ref, event);
            updateParticipantStage(event.participantId, "nudging-post-highlight", callbacks.setPage);
        });
    }

    else {
        let newEvent = {
            participantId: event.participantId,
            timestamp: Date.now(),
            highlights: []
        }

        for (let i = 0; i < event.highlights.length; i++) {
            let highlight = event.highlights[i];
            newEvent.highlights.push({
                start: highlight.start,
                end: highlight.end,
                text: highlight.text,
            });
        }

        addDoc(highlightedPassagesRef, newEvent).then((docRef) => {
            updateParticipantStage(event.participantId, "post-highlight", callbacks.setPage);

        }).catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
            // ...
        });
    }

}

export function logPostHighlightSurvey(event, callbacks) {

    if (experiment === "exp2-highlights") {
        addDoc(postHighlightHighlightsRef, event).then((docRef) => {
            updateParticipantStage(event.participantId, "nudging-test-instructions", callbacks.setPage);
        });
    }

    else if (experiment === "exp3-withinHighlights") {
        // update the dict of previous responses for the adjustment phase
        let response = {
            mentalDemand: event.mentalDemand,
            physicalDemand: event.physicalDemand,
            temporalDemand: event.temporalDemand,
            performance: event.performance,
            effort: event.effort,
            frustration: event.frustration,
            awareness: event.awareness,
        }
        callbacks.setPostHighlightResponses(prevResponses => {
            return { ...prevResponses, [event.condition]: response };
        });

        addDoc(postHighlightWithinHighlightsRef, event).then((docRef) => {
            let q = query(workersWithinHighlightsRef, where("workerId", "==", event.workerId));
            getDocs(q).then((querySnapshot) => {
                let latestDoc = querySnapshot.docs[querySnapshot.size - 1].data();

                // check which condition the participant is on
                if (latestDoc.currentIndex >= latestDoc.conditions.length - 1) {
                    updateParticipantStage(event.participantId, "nudging-post-highlight-adjust", callbacks.setPage);
                }

                else {
                    let currentIndex = latestDoc.currentIndex + 1;
                    callbacks.setCurrentIndex(currentIndex);

                    let nextCondition = latestDoc.conditions[currentIndex];
                    callbacks.setCondition(nextCondition);

                    callbacks.setPassage(latestDoc.passageTexts[nextCondition].replaceAll("_", " \n"));

                    updateParticipantData(event.participantId, { currentStage: "nudging-instructions", currentIndex: currentIndex });
                    callbacks.setPage("nudging-instructions");
                }

            })
        });
    }

    else {
        let newEvent = event;
        let timestamp = Date.now();
        newEvent.timestamp = timestamp;

        addDoc(postHighlightRef, newEvent).then((docRef) => {
            const q = query(workersRef, where("participantId", "==", event.participantId));
            getDocs(q).then((querySnapshot) => {
                let latestDoc = querySnapshot.docs[querySnapshot.size - 1];
                let completionCode = createCompletionCode("highlight");
                let numDays = 1;
                let unlockTime = timestamp + 1000 * 60 * 60 * 24 * numDays; // 1 day from now
                updateDoc(latestDoc.ref, { currentStage: "post-highlight-complete", highlightCompletionCode: completionCode, testUnlockTime: unlockTime });
                callbacks.setHighlightCompletionCode(completionCode);
                callbacks.setTestUnlockTime(unlockTime);
                callbacks.setPage("post-highlight-complete");
            });

        }).catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
            // ...
        });
    }
}

export function logPostHighlightAdjustSurvey(event, callbacks) {
    if (experiment === "exp3-withinHighlights") {
        addDoc(postHighlightAdjustWithinHighlightRef, event).then((docRef) => {
            const q = query(workersWithinHighlightsRef, where("participantId", "==", event.participantId));
            getDocs(q).then((querySnapshot) => {
                let latestDoc = querySnapshot.docs[querySnapshot.size - 1];
                let completionCode = createCompletionCode("highlight");
                let numDays = 1;
                let unlockTime = Date.now() + 1000 * 60 * 60 * 24 * numDays; // 1 day from now
                // let unlockTime = Date.now() + 1000 * 60; // FOR NOW: 1 min from now CHANGE ME
                updateDoc(latestDoc.ref, { currentStage: "post-highlight-complete", highlightCompletionCode: completionCode, testUnlockTime: unlockTime });
                callbacks.setHighlightCompletionCode(completionCode);
                callbacks.setTestUnlockTime(unlockTime);
                callbacks.setPage("post-highlight-complete");
            });
        });
    }
}

export function logReadingComprehensionSelection(event) {
    if (experiment === "exp2-highlights") {
        addDoc(readingComprehensionSelectionHighlightsRef, event).then((docRef) => { });
    }

    else if (experiment === "exp3-withinHighlights") {
        addDoc(readingComprehensionSelectionWithinHighlightsRef, event).then((docRef) => { });
    }

    else {
        let newEvent = event;
        newEvent.timestamp = Date.now();

        addDoc(readingComprehensionSelectionRef, newEvent).then((docRef) => {
        });
    }
}

export function logTest(event, callbacks) {
    if (experiment === "exp2-highlights") {
        addDoc(readingComprehensionHighlightsRef, event).then((docRef) => {
            updateParticipantData(event.participantId, { currentStage: "nudging-post-test", testEndTime: event.timestamp });
            callbacks.setPage("nudging-post-test");
        });
    }

    else if (experiment === "exp3-withinHighlights") {
        let q = query(readingComprehensionWithinHighlightsRef, where("participantId", "==", event.participantId), where("condition", "==", event.condition));
        getDocs(q).then((querySnapshot) => {
            let latestDoc = querySnapshot.docs[querySnapshot.size - 1];
            updateDoc(latestDoc.ref, event);

            if (event.currentIndex === 0) {
                prepareForUpcomingTest(event.participantId, callbacks);
            }

            else {
                updateParticipantStage(event.participantId, "nudging-post-test", callbacks.setPage);
            }

        });
    }

    else {
        let newEvent = event;
        newEvent.timestamp = Date.now();

        addDoc(readingComprehensionRef, newEvent).then((docRef) => {
            updateParticipantStage(event.participantId, "post-test", callbacks.setPage);
        });
    }
}

export function logPostTestSurvey(event, callbacks) {
    if (experiment === "exp2-highlights") {
        addDoc(postTestHighlightsRef, event).then((docRef) => {
            updateParticipantData(event.participantId, { currentStage: "nudging-post-test-complete", testCompletionCode: "C16IIXGR" });
            callbacks.setPage("nudging-post-test-complete");
            callbacks.setTestCompletionCode("C16IIXGR");
        });
    }

    else if (experiment === "exp3-withinHighlights") {
        addDoc(postTestWithinHighlightsRef, event).then((docRef) => {
            let completionCode = createCompletionCode("test");
            callbacks.setTestCompletionCode(completionCode);
            updateParticipantData(event.participantId, { currentStage: "post-test-complete", testCompletionCode: completionCode });
            callbacks.setPage("post-test-complete");
        });

    }

    else {
        let newEvent = event;
        newEvent.timestamp = Date.now();

        addDoc(postTestRef, newEvent).then((docRef) => {
            const q = query(workersRef, where("participantId", "==", event.participantId));
            getDocs(q).then((querySnapshot) => {
                let latestDoc = querySnapshot.docs[querySnapshot.size - 1];
                let completionCode = createCompletionCode("test");
                updateDoc(latestDoc.ref, { currentStage: "post-test-complete", testCompletionCode: completionCode });
                callbacks.setTestCompletionCode(completionCode);
                callbacks.setPage("post-test-complete");
            });

        });
    }
}

export function updateParticipantStage(participantId, stage, callback) {
    let q = null;
    if (experiment === "exp1-tweaking") {
        q = query(workersTweakingRef, where("participantId", "==", participantId));
    }
    else if (experiment === "exp2-highlights") {
        q = query(workersHighlightsRef, where("participantId", "==", participantId));
    }
    else if (experiment === "exp3-withinHighlights") {
        q = query(workersWithinHighlightsRef, where("participantId", "==", participantId));
    }
    else {
        q = query(workersRef, where("participantId", "==", participantId));
    }
    getDocs(q).then((querySnapshot) => {
        let latestDoc = querySnapshot.docs[querySnapshot.size - 1];
        updateDoc(latestDoc.ref, { currentStage: stage });
        callback(stage);
    });
}

export function updateParticipantData(participantId, data) {
    let q = null;
    if (experiment === "exp1-tweaking") {
        q = query(workersTweakingRef, where("participantId", "==", participantId));
    }
    else if (experiment === "exp2-highlights") {
        q = query(workersHighlightsRef, where("participantId", "==", participantId));
    }
    else if (experiment === "exp3-withinHighlights") {
        q = query(workersWithinHighlightsRef, where("participantId", "==", participantId));
    }
    else {
        q = query(workersRef, where("participantId", "==", participantId));
    }
    getDocs(q).then((querySnapshot) => {
        let latestDoc = querySnapshot.docs[querySnapshot.size - 1];
        updateDoc(latestDoc.ref, data);
    });
}

export function logStartTestEvent(event, callbacks) {
    if (experiment === "exp3-withinHighlights") {
        addDoc(readingComprehensionWithinHighlightsRef, event).then((docRef) => {
            const q2 = query(highlightedPassagesWithinHighlightsRef, where("participantId", "==", event.participantId), where("condition", "==", event.condition));
            getDocs(q2).then((pQuerySnapshot) => {
                let latestHighlightDoc = pQuerySnapshot.docs[pQuerySnapshot.size - 1].data();
                if (latestHighlightDoc.highlights) {
                    callbacks.setPreviousHighlights(latestHighlightDoc.highlights);
                }
                else {
                    callbacks.setPreviousHighlights([]);
                }


                callbacks.setTestStartTime(event.testStartTime);
                callbacks.setPage("test");
                updateParticipantStage(event.participantId, "test", callbacks.setPage)
            });

        });
    }
}

// Load in the highlights and passage
export function logStartTest(participantId, callbacks) {
    if (experiment === "exp2-highlights") {
        const q = query(workersHighlightsRef, where("participantId", "==", participantId));

        // Getting information about the participant
        getDocs(q).then((querySnapshot) => {
            let latestDoc = querySnapshot.docs[querySnapshot.size - 1];
            let timestamp = Date.now();
            updateDoc(latestDoc.ref, { currentStage: "nudging-test", testStartTime: timestamp }); // update the doc to the next stage

            // save the passage, start time, and load the questions
            callbacks.setPassage(latestDoc.data().passageText.replaceAll("_", " \n"));
            callbacks.setTestStartTime(timestamp);
            callbacks.setTestQuestions(latestDoc.data().testQuestions);

            // get the highlighted passage
            const q3 = query(highlightedPassagesHighlightsRef, where("participantId", "==", participantId));
            getDocs(q3).then((pQuerySnapshot) => {
                let latestPDoc = pQuerySnapshot.docs[pQuerySnapshot.size - 1];
                callbacks.setPreviousHighlights(latestPDoc.data().highlights);
                callbacks.setPage("nudging-test");
            });
        });
    }

    else {
        const q = query(workersRef, where("participantId", "==", participantId));

        // Getting information about the participant
        getDocs(q).then((querySnapshot) => {
            let latestDoc = querySnapshot.docs[querySnapshot.size - 1];
            let timestamp = Date.now();
            updateDoc(latestDoc.ref, { currentStage: "test", testStartTime: timestamp }); // update the doc to the next stage

            // save the passage and start time
            callbacks.setPassage(latestDoc.data().passageText.replaceAll("_", " \n"));
            callbacks.setTestStartTime(timestamp);

            // get the questions
            const q2 = query(passagesRef, where("passageId", "==", latestDoc.data().passageId));
            getDocs(q2).then((pQuerySnapshot) => {
                let latestPDoc = pQuerySnapshot.docs[pQuerySnapshot.size - 1];
                callbacks.setTestQuestions(latestPDoc.data().questions);
            });

            // get the highlighted passage
            const q3 = query(highlightedPassagesRef, where("participantId", "==", participantId));
            getDocs(q3).then((pQuerySnapshot) => {
                let latestPDoc = pQuerySnapshot.docs[pQuerySnapshot.size - 1];
                callbacks.setPreviousHighlights(latestPDoc.data().highlights);
                callbacks.setPage("test");
            });
        });
    }
}

export function logFinalTweakingSetting(participantId, event, callbacks) {
    addDoc(finalSettingsTweakingRef, event).then((docRef) => {
        // check if the participant has finished tweaking
        const q = query(workersTweakingRef, where("participantId", "==", participantId));
        getDocs(q).then((querySnapshot) => {
            let latestDoc = querySnapshot.docs[querySnapshot.size - 1];
            let conditionIndex = latestDoc.data().conditionIndex;
            let conditionOrder = latestDoc.data().conditionOrder;
            let currPass = latestDoc.data().pass;
            let nextConditionIndex = conditionIndex + 1;
            let nextCondition = conditionOrder[nextConditionIndex];

            // if the participant has finished all conditions for both passes, move them to the next stage
            if (currPass >= 2) {
                updateDoc(latestDoc.ref, { conditionIndex: nextConditionIndex, currentStage: "post-tweaking" });
                callbacks.setPage("post-tweaking");
            }

            // if the participant has finished all conditions for the current pass, move them to the next pass where they can further refine their settings
            else if (nextConditionIndex >= conditionOrder.length) {
                updateDoc(latestDoc.ref, { conditionIndex: 0, pass: currPass + 1 });
                callbacks.setPass(currPass + 1);
                callbacks.setCondition(conditionOrder[0]);
            }

            // otherwise, move them to the next condition
            else {
                updateDoc(latestDoc.ref, { conditionIndex: nextConditionIndex });
                callbacks.setCondition(nextCondition);
            }
        });
    });
}

export function logTweakingSetting(participantId, event, callbacks) {
    addDoc(settingsTweakingRef, event).then((docRef) => {
        // check if the participant has finished tweaking
        const q = query(workersTweakingRef, where("participantId", "==", participantId));
        getDocs(q).then((querySnapshot) => {
            let latestDoc = querySnapshot.docs[querySnapshot.size - 1];
            let conditionIndex = latestDoc.data().conditionIndex;
            let conditionOrder = latestDoc.data().conditionOrder;
            let currPass = latestDoc.data().pass;
            let nextConditionIndex = conditionIndex + 1;
            let nextCondition = conditionOrder[nextConditionIndex];

            // if the participant has finished all conditions for both passes, move them to the next stage
            if (currPass >= 2) {
                updateDoc(latestDoc.ref, { conditionIndex: nextConditionIndex, currentStage: "post-tweaking" });
                callbacks.setPage("post-tweaking");
            }

            // if the participant has finished all conditions for the current pass, move them to the next pass where they can further refine their settings
            else if (nextConditionIndex >= conditionOrder.length) {
                updateDoc(latestDoc.ref, { conditionIndex: 0, pass: currPass + 1 });
                callbacks.setPass(currPass + 1);
                callbacks.setCondition(conditionOrder[0]);
            }

            // otherwise, move them to the next condition
            else {
                updateDoc(latestDoc.ref, { conditionIndex: nextConditionIndex });
                callbacks.setCondition(nextCondition);
            }
        });
    });
}

export function logAllTweakingSettings(event) {
    // add the adjustment to the database
    addDoc(allSettingsTweakingRef, event).then((docRef) => { });
}

export function logTweakingFeedback(participantId, event, callbacks) {
    addDoc(postTweakingFeedbackRef, event).then((docRef) => {
        updateParticipantStage(participantId, "post-tweaking-complete", callbacks.setPage);
    });
}